import { TableHeaderRowGroup, TableRow } from '@ksyos/design-system';
import { translateKey } from '../../../../translate';

export interface IPersonalSettingsCarePathOverViewDetailsHeaderProps {
    carePathName: string;
    inactiveFlag?: JSX.Element;
}

export function PersonalSettingsCarePathOverViewDetailsHeader(
    props: IPersonalSettingsCarePathOverViewDetailsHeaderProps
) {
    return (
        <TableRow>
            <TableHeaderRowGroup colSpan={4}>
                {translateKey(`episodeCategoryEnum.${props.carePathName}`)} {props.inactiveFlag}
            </TableHeaderRowGroup>
        </TableRow>
    );
}
